import { __awaiter } from "tslib";
/**
 * @desc 系统配置模块
 */
import { systemAxios, systemAxiosDirect } from '../httpInstance';
/** @description ：运营列表
 *
 */
export function operatingData(payload) {
    return __awaiter(this, void 0, void 0, function* () {
        return systemAxios({
            method: 'POST',
            url: 'getBannerList',
            data: JSON.stringify(payload),
            headers: {
                'Content-Type': 'application/json',
            },
        });
    });
}
// 成功提示成功，失败提示失败 成功回调
/** @description ：上架/下架
 *
 */
export function changeShelves(payload, url) {
    return __awaiter(this, void 0, void 0, function* () {
        return systemAxios({
            method: 'get',
            url,
            params: payload,
        });
    });
}
/** @description ：创建轮播图
 *
 */
export function createBanner(payload) {
    return __awaiter(this, void 0, void 0, function* () {
        return systemAxios({
            method: 'POST',
            url: 'createBanner',
            data: JSON.stringify(payload),
            headers: {
                'Content-Type': 'application/json',
            },
        });
    });
}
/**
 * 编辑轮播图
 */
export function editBanner(payload) {
    return __awaiter(this, void 0, void 0, function* () {
        return systemAxios({
            method: 'POST',
            url: 'editBanner',
            params: payload,
        });
    });
}
/**
 * 查看轮播图
 */
export function watchBanner(payload) {
    return __awaiter(this, void 0, void 0, function* () {
        return systemAxios({
            method: 'get',
            url: 'getBannerInfo',
            params: payload,
        });
    });
}
/** @description ：编辑轮播图
 *
 */
export function detailShufflingPicData(payload) {
    return __awaiter(this, void 0, void 0, function* () {
        return systemAxios({
            method: 'POST',
            url: 'detailShufflingPic',
            params: payload,
        });
    });
}
/** @description ：编辑轮播图
 *
 */
export function editShufflingPicData(payload) {
    return __awaiter(this, void 0, void 0, function* () {
        return systemAxios({
            method: 'POST',
            url: 'editShufflingPic',
            params: payload,
        });
    });
}
// 导出
export const globalExport = (params) => {
    return systemAxiosDirect({
        url: 'systemExport',
        method: 'POST',
        responseType: 'blob',
        data: params,
    });
};
